import { initWidget } from './widget';
import endpoints from './widget/define/endpoints';

import Profile from './widget/component/Profile';

const initUserProfilePageWidgets = () => {
    const props = {
        endpoints,
    };

    initWidget('profile', Profile, props);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUserProfilePageWidgets.bind(this));
} else {
    initUserProfilePageWidgets();
}